import axios from 'axios'

function initialState() {
  return {
    config: null,
    tenantId: null,
    widgetStates: {},
  }
}

export default {
  namespaced: true,
  state: initialState,
  actions: {
    async fetchDashboardConfig({ commit, state, rootGetters }) {
      const tenantId = rootGetters['authenticate/currentTenant'] &&
        rootGetters['authenticate/currentTenant'].id
      if (state.config != null && state.tenantId === tenantId) {
        return state.config
      }
      try {
        const res = await axios.get('api/Dashboard/Config')
        commit('SET_CONFIG', { config: res.data, tenantId })
        return res.data
      } catch (err) {
        commit('SET_CONFIG_ERROR')
        throw err
      }
    },
    setWidgetLoading({ commit }, { widgetId }) {
      commit('SET_WIDGET_LOADING', { widgetId })
    },
    setWidgetData({ commit }, { widgetId, data }) {
      commit('SET_WIDGET_DATA', { widgetId, data })
    },
    setWidgetError({ commit }, { widgetId, error }) {
      commit('SET_WIDGET_ERROR', { widgetId, error })
    },
  },
  mutations: {
    SET_CONFIG(state, { config, tenantId }) {
      state.config = config
      state.tenantId = tenantId
      state.widgetStates = {}
    },
    SET_CONFIG_ERROR(state) {
      state.config = null
      state.tenantId = null
    },
    SET_WIDGET_LOADING(state, { widgetId }) {
      state.widgetStates = {
        ...state.widgetStates,
        [widgetId]: { loading: true, error: null, data: null, initialized: false },
      }
    },
    SET_WIDGET_DATA(state, { widgetId, data }) {
      state.widgetStates = {
        ...state.widgetStates,
        [widgetId]: { loading: false, error: null, data, initialized: true },
      }
    },
    SET_WIDGET_ERROR(state, { widgetId, error }) {
      state.widgetStates = {
        ...state.widgetStates,
        [widgetId]: { loading: false, error, data: null, initialized: false },
      }
    },
    RESET(state) {
      const s = initialState()
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    },
  },
  getters: {
    dashboardConfig: state => state.config,
    widgetState: state => (widgetId) => state.widgetStates[widgetId] || null,
    isDashboardEnabled: state => state.config != null,
  },
}
